exports.endianness = function () {
  return 'LE';
};
exports.hostname = function () {
  if (typeof location !== 'undefined') {
    return location.hostname;
  } else return '';
};
exports.loadavg = function () {
  return [];
};
exports.uptime = function () {
  return 0;
};
exports.freemem = function () {
  return Number.MAX_VALUE;
};
exports.totalmem = function () {
  return Number.MAX_VALUE;
};
exports.cpus = function () {
  return [];
};
exports.type = function () {
  return 'Browser';
};
exports.release = function () {
  if (typeof navigator !== 'undefined') {
    return navigator.appVersion;
  }
  return '';
};
exports.networkInterfaces = exports.getNetworkInterfaces = function () {
  return {};
};
exports.arch = function () {
  return 'javascript';
};
exports.platform = function () {
  return 'browser';
};
exports.tmpdir = exports.tmpDir = function () {
  return '/tmp';
};
exports.EOL = '\n';
exports.homedir = function () {
  return '/';
};